import React from 'react';
import { datagrid, tabularFormatters } from '@local/finsera-core/src/helpers';
import { useWindowDimensions } from '@local/finsera-core/src/hooks';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import FinDataGrid from '../../../fin-data-grid';
// import Tabular from 'views/report/tables/tabular';

type LocateConstraintProps = {
  params: types.optimizer.Locate[];
};

const LocateConstraint = ({ params }: LocateConstraintProps) => {
  const [containerWidth, setContainerWidth] = React.useState(0);
  const locateArr = React.useMemo(() => {
    return params
      .map((v) => {
        return {
          ...v,
          id: v.asset_fids?.[0],
          fid: v.asset_fids?.[0],
          asset_fids: undefined as any,
        };
      })
      .filter((v) => v.status != 'UNLOCATED');
  }, []);

  const columns = [
    {
      name: 'Asset',
      key: 'fid',
    },
    {
      name: 'Name',
      key: 'name',
    },
    {
      name: 'Ticker',
      key: 'ticker',
      formatter: tabularFormatters.formatTo('string', { align: 'left' }),
    },
    {
      name: 'Requested Shares',
      key: 'requested_shares',
      formatter: tabularFormatters.formatTo('integer', { align: 'right' }),
    },
    {
      name: 'Approved Shares',
      key: 'approved_shares',
      formatter: tabularFormatters.formatTo('integer', { align: 'right' }),
    },
    {
      name: 'Status',
      key: 'status',
    },
    {
      name: 'Note',
      key: 'note',
    },
  ];

  const mappedColumns = React.useMemo(() => {
    return datagrid.buildMappedColumns({
      dataColumns: columns,
      data: locateArr,
      columnsWidth: [
        { columnKey: 'fid', columnWidth: 100 },
        { columnKey: 'ticker', columnWidth: 100 },
        { columnKey: 'status', columnWidth: 100 },
      ],
    });

  }, [columns, locateArr]);

  const container = React.createRef<HTMLDivElement>();

  const { height, width } = useWindowDimensions(0);
  React.useEffect(() => {
    if (container.current) {
      setContainerWidth(container.current.offsetWidth);
    }
  }, [width, height]);

  return (
    <mui.core.Box ref={container}>
      <mui.core.Box sx={{ width: containerWidth, height: '400px' }}>
        <FinDataGrid
          rows={locateArr}
          columns={mappedColumns as any}
          initialState={{ density: 'compact' }}
          disableColumnReorder
          hideFooter
          hideFooterPagination
        />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default LocateConstraint;
